import * as React from 'react';

import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Styles } from "./../HelperClasses/Styles";


//=========================================================================================//
//Try to mimic the font awsomeprops
export interface IMyIconProps {
    size?: number;
    color?: string;
}


//=========================================================================================//
export const XCIcon: React.FC<any> = (props) => {
    const jsx =
        <span className="d-inline-block text-center fa-layers fa-fw">
            <FontAwesomeIcon icon='plane' transform='shrink-4 left-5 down-4' />
            <FontAwesomeIcon icon='globe' transform='shrink-4 right-5 up-4' />
        </span>

    return jsx;

}

export const NoFilterIcon: React.FC<any> = (props) => {

    const jsx =
        <span className="d-inline-block text-center fa-layers fa-fw">
            <FontAwesomeIcon icon={faXmark} transform='shrink-4 right-10 down-6' />
            <FontAwesomeIcon icon="filter" />
        </span>
    return jsx;
}

export interface ISortIconProps {
    size?: SizeProp;
    color?: string;

    state?: 'asc' | 'desc' | 'double' | 'none';
}
export const SortIcon: React.FC<any> = ({ size, color, state }: ISortIconProps) => {
    
    const baseClasses = "d-inline-block text-center fa-layers fa-fw";

    if (state === 'asc') {
        return (
            <span className={baseClasses}>
            <FontAwesomeIcon icon="arrow-up" transform='shrink-8' size={size} color={color} />
            </span>
        )
    }
    else if (state === 'desc') {
        return (
            <span className={baseClasses}>
                <FontAwesomeIcon icon="arrow-down" transform='shrink-8' size={size} color={color} />
            </span>
        )
    }
    else if (state === 'double') {
        return (
            <span className={baseClasses}>
                <FontAwesomeIcon icon="arrow-up" transform='shrink-8 left-3 up-2' size={size} color={color} />
                <FontAwesomeIcon icon="arrow-down" transform='shrink-8 right-3 down-2' size={size} color={color} />
            </span>)
    }
    else {
        return null;
    }
}
//=========================================================================================//
export interface IInstructionIconProps {


}

export const InstructionIcon: React.FC<IInstructionIconProps> = (props) => {
    return getInstructionIcon(props);
}

const getInstructionIcon = (props: IInstructionIconProps): JSX.Element => {
    const jsx =
        <span className="d-inline-block text-center fa-layers fa-fw">
            <FontAwesomeIcon icon='plane' transform='shrink-4 left-5 down-4' />
            <FontAwesomeIcon icon='chalkboard-teacher' transform='shrink-4 right-5 up-4' />
        </span>

    return jsx;
}

//=========================================================================================//

export interface IPaidIconProps {

    isPaid: boolean;
}

export const PaidIcon: React.FC<IPaidIconProps> = (props) => {
    return getPaidIcon(props.isPaid);
}

const getPaidIcon = (paid: boolean): JSX.Element => {
    if (paid) {
        return <FontAwesomeIcon icon="coins" inverse style={Styles.getOKColorStyle()} />
    }
    else {
        return <span className="d-inline-block text-center fa-layers fa-fw">
            <FontAwesomeIcon icon="slash" style={Styles.getErrorColorStyle()} />
            <FontAwesomeIcon icon="coins" style={Styles.getErrorColorStyle()} />
        </span>
        //return <FontAwesomeIcon icon="coins" inverse style={Styles.getFontErrorStyle()} />
    }
}

//=========================================================================================//


export const EventIcon: React.FC<IMyIconProps> = (props: IMyIconProps) => {
    return getEventIcon(props);
}
//d-inline-block w-100 text-center but the W-100 is sometimes a problem?
export const getEventIcon = (props: IMyIconProps): JSX.Element => {
    let style = 'd-inline-block text-center fa-layers fa-fw'
    if (props && props.size) {
        style = style + ' fa-' + props.size.toString() + 'x';
    }
    const jsx =
        <span className={style} >
            <FontAwesomeIcon icon='arrow-left' transform='rotate-45 shrink-10 right-5 down-5 ' color={props && props.color ? props.color : ''} />
            <FontAwesomeIcon icon='arrow-left' transform='rotate-135 shrink-10 left-5 down-5 ' color={props && props.color ? props.color : ''} />
            <FontAwesomeIcon icon='arrow-left' transform='rotate-225 shrink-10 left-5 up-5' color={props && props.color ? props.color : ''} />
            <FontAwesomeIcon icon='arrow-left' transform='rotate-315 shrink-10 right-5 up-5 ' color={props && props.color ? props.color : ''} />
            <FontAwesomeIcon icon='users' transform='shrink-10 ' color={props && props.color ? props.color : ''} />
        </span>

    return jsx;
}
